// Wraps every case-insensitive match of `query` inside `text` with a
// <mark> tag. Used across Documents, FAQ, and Tutorials so users see
// *why* a row matched their search. Renders plain text when query empty.

const MARK_STYLE = {
    background: '#FEF3C7',  // soft amber — matches a highlighter feel
    color: 'inherit',
    padding: '0 1px',
    borderRadius: 2,
};

export default function Highlight({ text, query }) {
    if (!text) return null;
    const q = (query || '').trim();
    if (!q) return text;

    // Escape regex special chars so a user typing "(" doesn't crash the regex.
    const escaped = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const parts = String(text).split(new RegExp(`(${escaped})`, 'gi'));

    return (
        <>
            {parts.map((part, i) =>
                part.toLowerCase() === q.toLowerCase()
                    ? <mark key={i} style={MARK_STYLE}>{part}</mark>
                    : <span key={i}>{part}</span>
            )}
        </>
    );
}
